import { useQuery } from "react-query";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

const getCountryCodes = async () => {
  const { data } = await getDataWithDotNet(ajaxEndpoints.COUNTRY_CODES_URL);
  return data;
};

export default function useCountryCodes() {
  return useQuery(["getCountryCodes"], getCountryCodes, {
    refetchOnWindowFocus: false,
  });
}
